module.exports = __webpack_public_path__ + "img/topic-iletisim.f4bb9940.svg";